// extracted by mini-css-extract-plugin
export default {"item":"result-item_item__WrF6I","vertical":"result-item_vertical__+pyKQ","horizontal":"result-item_horizontal__l6O17","label":"result-item_label__4ANhR"};